import { Layout, Typography, Card, Flex, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
    MailOutlined,
    CustomerServiceOutlined
} from '@ant-design/icons';
import logo from '../../assets/images/nova-logo-blue-text.png';
import logo2 from '../../assets/images/nova-new-logo-white-text.png';
import { useEffect } from 'react';
import './ContactPage.scss';

const { Header, Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const ContactPage = () => {
    const navigate = useNavigate();


    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    return (
        <Layout className="landing-layout">
            <Header className="landing-header">
                <Flex align="center" justify="space-between" className="nav-container">
                    <Flex className="logo-section">
                        <img
                            src={logo}
                            alt="Logo"
                            height={40}
                            onClick={() => navigate('/')}
                            style={{ cursor: 'pointer' }}
                        />
                    </Flex>

                    <Flex align="center" className="menu-section">
                        <Space className="auth-buttons">
                            <Button
                                type="link"
                                onClick={() => navigate('/login')}
                            >
                                Login
                            </Button>
                            {/* <Button
                                type="primary"
                                onClick={() => navigate('/signup')}
                            >
                                Request a Demo
                            </Button> */}
                        </Space>
                    </Flex>
                </Flex>
            </Header>

            <Content>
                <div className="contact-page">
                    <Flex vertical align="center" className="contact-content">
                        <div className="header-section">
                            <CustomerServiceOutlined className="header-icon" />
                            <Title level={1}>Contact Us – We're Here to Help!</Title>
                            <Paragraph className="subtitle">    
                                If you have any questions, concerns, or need assistance, feel free to reach out.
                                Our team is here to support you and provide the information you need.
                            </Paragraph>
                        </div>

                        <Flex justify='center' className="methods-grid">
                            <Card className="method-card">
                                <MailOutlined className="method-icon" />
                                <Title level={3}>Email Us</Title>
                                <Paragraph>
                                    To get in touch via email, please use{' '}
                                    <Text strong>
                                    info[at]supernovacrm[dot]com
                                    </Text>
                                </Paragraph>

                            </Card>
                        </Flex>
                    </Flex>
                </div>
            </Content>

            {/* Add Footer */}
            <div className="footer-section">
                <Flex className="footer-content">
                    <div className="footer-grid">
                        <div className="footer-column">
                            <img src={logo2} alt="Logo" height={100} />
                            <Paragraph>
                                Empowering organizations with smart donor management solutions.
                            </Paragraph>
                        </div>

                        <div className="footer-column">
                            <Button 
                                type="link" 
                                onClick={() => navigate('/contact')}
                            >
                                Contact Support Team
                            </Button>
                        </div>
                    </div>
                </Flex>
                <div className="footer-bottom">
                    <Text>© {new Date().getFullYear()} Nova CRM. All rights reserved.</Text>
                </div>
            </div>
        </Layout>
    );
};

export default ContactPage; 